import * as React from "react"

function SvgWarning(props) {
  return (
    <svg
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M10.893 11.56V7.9H9.107v3.66h1.786zm0 3.617v-1.83H9.107v1.83h1.786zM0 17.9L10 .667 20 17.9H0z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgWarning
